import React, { useState, useContext, useEffect, useRef } from "react";
import dynamic from "next/dynamic";
// import { motion, AnimatePresence } from "framer-motion";

import Container from "react-bootstrap/Container";
import { HeaderContext, NavContext } from "contexts/";
import { useRouter } from "next/router";
import FadeInOut from "@components/Animations/FadeInOut";
import FallInstituteNavigation from "@components/Reusables/FilterBar/FallInstituteNavigation";
import ConferenceNavigation from "@components/Reusables/FilterBar/ConferenceNavigation";
import BoardApplyNavigation from "@components/Reusables/FilterBar/BoardApplyNavigation";

import { colors } from "utils/styles";
import { useMobileNavResize, useScrollPositionLimit } from "hooks";
import { NotificationDialog } from "./components";
const DynamicDesktopHeader = dynamic(() => import("./components/DesktopHeader"), {
	loading: () => <header />,
});

const DynamicMobileHeader = dynamic(() => import("./components/MobileHeader"), {
	loading: () => <header />,
});

export default function Header() {
	const { setIsMobileNavOpen, isMobileNavOpen, notificationDialogue } = useContext(HeaderContext);
	const router = useRouter();
	const [megaNavName, setMegaNavName] = useState("");
	const [hasSubNav, setHasSubNav] = useState(checkForSubNav(router.pathname));
	const [hasRegistrationNav, setHasRegistrationNav] = useState(checkRegistrationNavBreadCrumbs(router.pathname));
	const [userDropdownOpen, setUserDropdownOpen] = useState(false);
	const footerOnScreen = false;
	const [webinars, setWebinars] = useState([]);


	useMobileNavResize({ setIsMobileNavOpen, isMobileNavOpen, megaNavName, setMegaNavName });

	useEffect(() => {
		function onBeforeUnload(path) {
			setHasRegistrationNav(checkRegistrationNavBreadCrumbs(path));
			setHasSubNav(checkForSubNav(path));
		}

		router.events.on("routeChangeStart", onBeforeUnload);

		return () => {
			router.events.off("routeChangeStart", onBeforeUnload);
		};
	}, [router.pathname, hasSubNav, hasRegistrationNav]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await fetch('/api/webinars', { cache: "force-cache", next: { revalidate: 3600 } }); // 1 hour
				if (!res.ok) {
					return;
				}
				const t = await res.json();
				setWebinars(t);
			}
			catch (err) { }
		};

		fetchData();
	}, []);

	const scrollHeaderLimit = useScrollPositionLimit({
		limitOn: hasSubNav ? 500 : 300, //TODO ENV VAR?
		limitOff: hasSubNav ? 50 : 50,
		isMobileNavOpen,
		hasRegistrationNav,
	});

	function closeNav() {
		setMegaNavName("");
		setIsMobileNavOpen(false);
	}
	useEffect(() => {
		//closes the navigation when path changes
		closeNav();
	}, [router.pathname]);

	return (
		<NavContext.Provider
			value={{
				megaNavName,
				setMegaNavName,
				closeNav,
				scrollHeaderLimit,
				hasSubNav,
				userDropdownOpen,
				setUserDropdownOpen,
				webinars
			}}
		>
			<div
				className={`${!hasRegistrationNav && "sticky-top"} z-index-10 ${
					scrollHeaderLimit && !footerOnScreen ? " boxShadow" : ""
				}`}
			>
				<FadeInOut
					animate={!scrollHeaderLimit && !isMobileNavOpen ? "visible" : "hidden"}
					myKey={"NotificationDialog"}
				>
					<NotificationDialog notificationDialogue={notificationDialogue} />
				</FadeInOut>
				<Container fluid className="g-0 container-lg">
					{/* announcement bar */}

					<div className={``}>
						{/* Desktop Header/Nav */}
						<DynamicDesktopHeader
							hasRegistrationNav={hasRegistrationNav}
							hasSubNav={hasSubNav}
							slimNav={scrollHeaderLimit}
						/>
						{/* Mobile Header/Nav  */}
						<DynamicMobileHeader
							hasRegistrationNav={hasRegistrationNav}
							hasSubNav={hasSubNav}
							slimNav={scrollHeaderLimit}
						/>
					</div>
				</Container>

				<style jsx="true" global>{`
					html,
					body {
						padding: 0;
						margin: 0;
						font-family: "Open Sans", Helvetica Neue, Arial, sans-serif;
					}

					* {
						box-sizing: border-box;
					}

					.btn-MENU {
						background: ${colors.darkBlue};
						color: ${colors.white};
						font-size: 13px;
						align-items: center;
						display: flex;
						height: 2em;
						width: 90px;
					}
					.btn-MENU:hover {
						color: white;
						background: ${colors.darkBlue};
					}
				`}</style>
			</div>
		</NavContext.Provider>
	);
}

function checkRegistrationNavBreadCrumbs(path) {
	if (path.includes("/conference/registration")) {
		return true;
	} else if (path.includes("/fall-institute/registration")) {
		return true;
	}
}
function checkForSubNav(path) {
	// return false;
	if (path.includes("/fall-institute/registration")) {
		return false;
	} else if (path.includes("/fall-institute")) {
		return FallInstituteNavigation;
	} else if (path.includes("/conference")) {
		return ConferenceNavigation;
	} else if (path.includes("/about/board")) {
		return BoardApplyNavigation;
	}
}
